import { EXPRESS_API } from 'configs/api/expressApi';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import {
  CreateCustomReportParams,
  QueryListParams,
  UpdateRecurringParams,
} from '.';

const DATE_FORMAT = 'YYYY-MM-DD';

export const getCustomReports = async (start: number, limit: number) => {
  const response = await EXPRESS_API.get(`/custom-reports`, {
    params: { start, limit },
  });
  return response.data;
};

export const getCustomReport = async (reportId: string) => {
  const response = await EXPRESS_API.get(`/custom-reports/${reportId}`);
  return response.data;
};

export const createCustomReport = async ({
  data,
}: CreateCustomReportParams) => {
  const response = await EXPRESS_API.post(`/custom-reports`, data);
  return response.data;
};

export const updateCustomReport = async ({
  reportId,
  data,
}: CreateCustomReportParams) => {
  const response = await EXPRESS_API.put(`/custom-reports/${reportId}`, data);
  return response.data;
};

export const deleteCustomReport = async (reportId: string) => {
  await EXPRESS_API.delete(`/custom-reports/${reportId}`);
  return { reportId };
};

export const createRecurring = async ({
  reportId,
  data,
}: CreateCustomReportParams) => {
  const response = await EXPRESS_API.post(
    `/custom-reports/${reportId}/recurrings`,
    data
  );
  return response.data;
};

export const updateRecurring = async ({
  reportId,
  recurringId,
  data,
}: UpdateRecurringParams) => {
  const response = await EXPRESS_API.put(
    `/custom-reports/${reportId}/recurrings/${recurringId}`,
    data
  );
  return response.data;
};

export const deleteRecurring = async (
  reportId: string,
  recurringId: string
) => {
  await EXPRESS_API.delete(
    `/custom-reports/${reportId}/recurrings/${recurringId}`
  );
  return { reportId, recurringId };
};

export const getCustomReportHistory = async ({
  reportId,
  page = 0,
  size = 10,
}: QueryListParams) => {
  const start = page * size;

  const response = await EXPRESS_API.get(
    `/custom-reports/${reportId}/history`,
    {
      params: {
        start,
        limit: size,
      },
    }
  );
  return response.data;
};

export const getCustomReportData = async (
  reportId: string,
  from: Date,
  to: Date
) => {
  const response = await EXPRESS_API.get(`/custom-reports/${reportId}/data`, {
    params: {
      to: dayjs(to).format(DATE_FORMAT),
      from: dayjs(from).format(DATE_FORMAT),
    },
  });
  return response.data;
};

export const downloadCustomReportData = async (
  reportId: string,
  name: string,
  from: Date,
  to: Date
) => {
  const response = await EXPRESS_API.get(
    `/custom-reports/${reportId}/download`,
    {
      params: {
        to: dayjs(to).format(DATE_FORMAT),
        from: dayjs(from).format(DATE_FORMAT),
      },
      responseType: 'blob',
    }
  );

  return saveAs(new Blob([response.data]), name);
};
